import "./Home.css";
import { Colors } from "../../consts/Colors";
import { useNavigate } from "react-router-dom";
import Subtitle from "../../components/Subtitle";
import Title from "../../components/Title";
import PROJECTS from "../../consts/projects";
import Page from "../../components/Page";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaGithubSquare } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { SiPeerlist } from "react-icons/si";
import WorkExp from "./WorkExp";

export const Padding = ({ height }) => {
  return <div style={{ height }} />;
};
export const PaddingVr = ({ width }) => {
  return <div style={{ width }} />;
};

export const Link = ({ to, children }) => {
  const nav = useNavigate();
  return (
    <span
      onClick={() => {
        nav(to);
      }}
      className="underline_on_hover"
    >
      {children}
    </span>
  );
};

const SOCIALS = [
  {
    title: "Github",
    Icon: <FaGithubSquare size={25} />,
    url: "https://github.com/shreyasg-git/",
  },
  {
    title: "Twitter/X",
    Icon: <FaSquareXTwitter size={25} />,
    url: "https://twitter.com/shreyasbg28",
  },
  {
    title: "LinkedIn",
    Icon: <FaLinkedin size={25} />,
    url: "https://www.linkedin.com/in/shreyas-gangurde-1438981a1/",
  },
  {
    title: "Peerlist",
    Icon: <SiPeerlist size={25} />,
    url: "https://peerlist.io/shreyasbg",
  },
];

export const Socials = () => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        alignItems: "center",
      }}
    >
      {SOCIALS.map((social) => {
        return (
          <div
            onClick={() => window.open(social.url, "_blank", "noopener")}
            className="socials-container"
            style={{
              height: "auto",
              borderRadius: "7px",
              width: "fit-content",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              padding: "10",
              margin: 10,
            }}
          >
            {social.Icon}
            <PaddingVr width={10} />
            <Subtitle>{social.title}</Subtitle>
          </div>
        );
      })}
    </div>
  );
};

export const ProjectTile = ({ project }) => {
  return (
    <div
      style={{
        display: "flex",
        width: "800px",
        borderRadius: "12px",
        margin: "1rem",
      }}
    >
      <div
        style={{
          backgroundColor: Colors.floatBg,
          borderRadius: "12px 0 0 12px",
          display: "flex",
          justifyContent: "center",
          padding: "1rem",
          borderRight: `1px solid ${Colors.border}`,
        }}
      >
        <Subtitle>{project.year}</Subtitle>
      </div>
      <div
        style={{
          backgroundColor: Colors.floatBg,
          borderRadius: "0 12px 12px 0",
          justifyContent: "center",
          padding: "1rem",
        }}
      >
        <Title>{project.title}</Title>
        <br />
        <br />
        <Subtitle>{project.description}</Subtitle>
        <br />
        {project.links ? (
          project.links
        ) : (
          <Link to={`reports${project.reportRoute}`}>Project Report</Link>
        )}
      </div>
    </div>
  );
};

const Home = () => {
  return (
    <>
      <Page freeWidth nav>
        <div style={{ height: "20px" }} />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div style={{ maxWidth: "1000px", margin: "1rem" }}>
            <Subtitle>Hey, I am Shreyas. </Subtitle>
            <br />
            <Subtitle>
              I am a software engineer passionate about Startups, Product
              Engineering and a little Computer Science on the side. I like to
              build products, study computers and read books.
            </Subtitle>
            <br />
            <Subtitle>
              I am a self-taught developer, interested in using my skills to my
              full potential to build great products. I have always been
              fascinated by product designers, and Product Managers and I love
              to hang out with them and discuss things. I am currently looking
              for a job at a product based startup!!!
            </Subtitle>
            <Padding height={30} />
            <Socials />
          </div>
          <img
            src="./profile.jpeg"
            alt=""
            style={{ borderRadius: "30px", height: "300px", margin: "2rem" }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flex: 1,
          }}
        >
          <h2>Work Experience</h2>
          <Padding height="1rem" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <WorkExp />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flex: 1,
          }}
        >
          <h2>My Projects</h2>
          <Padding height="1rem" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {PROJECTS.map((proj) => {
              return <ProjectTile project={proj} />;
            })}
          </div>
        </div>
      </Page>
    </>
  );
};

export default Home;
